export default "__VITE_ASSET__nq5fF3wF__"